<template>
  <el-select 
    v-model="selectedValue"
    :style="{width: width}"
    placeholder="请选择往来单位"
    clearable
    filterable
  >
    <el-option
      v-for="item in partnerList"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    />
  </el-select>
</template>

<script>
import requestTicket from '@/utils/requestTicket'

export default {
  name: 'SaleTypeLov',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    width: {
      type: String,
      default: '150px'
    }
  },
  data() {
    return {
      partnerList: [],
      selectedValue: this.value
    }
  },
  watch: {
    selectedValue(newVal) {
      // 返回选中对象的完整信息
      this.$emit('callBack', this.partnerList?.find(item => item.id === newVal))
    },
    value(newVal) {
      this.selectedValue = newVal
    }
  },
  mounted() {
    this.fetchPartnerList()
  },
  methods: {
    async fetchPartnerList() {
      try {
        const res = await requestTicket.post('/Ticketing/sale-type/findAll')
        this.partnerList = res.data || []
      } catch (error) {
        console.error('获取往来单位列表失败:', error)
      }
    }
  }
}
</script>